// 域名信息
import axios from "axios";
const qs = require('qs');
import { Message, Loading } from "element-ui";
import router from "../../router";
import { proApi } from "./api";
import { devApi } from "./dev-api";
import { testApi } from "./test-api";
const imgUrlBase = "http://school-app-res.elyshop.cn/";
// 开发模式
const debug_mode = 2; // 1 开发环境 2 线上环境  3 测试环境
const api = debug_mode === 1 ? devApi : debug_mode === 2 ? proApi : testApi;

axios.timeout = 5000; // 超时10秒
// 请求拦截
axios.interceptors.request.use(
  config => {
    return Promise.resolve(config);
  },
  error => {
    Message.closeAll();
    Message.error({ message: "请求超时!" });
    // router.push("/login");
    return Promise.reject(error);
  }
);
// 响应拦截
axios.interceptors.response.use(
  response => {
    // console.groupCollapsed(`发送请求：`, response.request.responseURL);
    // console.log("请求头配置>>>：", response.request);

    // 根据后台返回的判断标识来抛出promise的处理方式
    if (response.data.success) {
      // console.log("返回成功>>>：", response);
      // console.log(
      //   "then的数据>>>：",
      //   response.data.result !== undefined && response.data.result !== null
      //     ? response.data.result
      //     : response.data
      // );
      // console.groupEnd();
      return Promise.resolve(response);
    } else {
      console.log("返回失败>>>： ", response);
      console.log("catch的数据>>>：", response.data.message || response.data);
      // console.groupEnd();
      Message.closeAll();
      Message.error({ message: response.data.message });
      return Promise.reject(response.data.message || response.data);
    }
  },
  error => {
    // console.groupCollapsed(`发送请求：`, error.request.url);
    console.log("请求头配置>>>：", error.request);
    let toastMsg = (error.response.data && error.response.data.message) || "";
    if (
      error.code === "ECONNABORTED" ||
      error.message === "Network Error" ||
      error.response.status === 504
    ) {
      toastMsg = "网络超时，请重试！";
    }
    if (error.response.status === 503) {
      toastMsg = "服务器数据异常!";
    }
    if (error.response.status === 502) {
      toastMsg = "服务器正在重启";
    }
    if (error.response.status === 500) {
      toastMsg = "数据加载异常，请重试";
    }
    if (error.response.status === 401) {
      toastMsg = "登录已过期，请重新登录";
    }
    if (error.response.status === 404) {
      toastMsg = "404: 请求失败";
    }
    Message.closeAll();
    Message.error({ message: toastMsg, center: true });
    // console.log("返回失败>>>： ", error);
    // console.log("catch的数据>>>：", error.response.data);
    // console.groupEnd();
    return Promise.reject(error.response.data);
  }
);
//GET传参序列化
axios.interceptors.request.use(
  config => {
    if (config.method === "get") {
      // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2,不转换会显示为arr[]=1&arr[]=2
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 接口差异对比
let maxApi =
  Object.keys(devApi).length > Object.keys(proApi).length
    ? Object.keys(devApi)
    : Object.keys(proApi);
maxApi =
  maxApi.length > Object.keys(testApi).length ? maxApi : Object.keys(testApi);

let diffApi = maxApi.filter(apiName => {
  return Object.keys(api).indexOf(apiName) === -1;
});
// console.groupCollapsed(
//   `debug模式：`,
//   ["1 开发环境", "2 线上环境", "3 测试环境"][debug_mode - 1]
// );
console.info("当前API环境:", api);
console.info(`当前API环境缺少的接口:${diffApi.length}个`);
if (diffApi.length > 0) {
  console.error(
    `${["dev-api.js", "api.js", "test-api.js"][debug_mode - 1]}缺少${
      diffApi.length
    }个接口`,
    diffApi
  );
}
// console.groupEnd();
// 接口差异对比 End

export { debug_mode, imgUrlBase, api, axios };



// WEBPACK FOOTER //
// ./src/assets/api/http.js